export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'movie', name: '电影', slug: 'movie' },
  { id: 'tv', name: '电视剧', slug: 'tv' },
  { id: 'variety', name: '综艺', slug: 'variety' },
  { id: 'anime', name: '动漫', slug: 'anime' },
  { id: 'documentary', name: '纪录片', slug: 'documentary' },
  { id: 'short', name: '短视频', slug: 'short' },
  { id: 'music', name: '音乐', slug: 'music' },
];